import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Icon,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
  Card,
  FormHelperText,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { RoleListService } from "layouts/role/services/RoleService";

export function UserEdit({
  open,
  handleClose,
  datosRecuperados,
  datosEditados,
  isFormModified,
  isDisabled,
  getFieldValue,
  handleFieldChange,
  handleSubmit,
  listRoles,
  isFieldValid,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "400px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };

  // List Role Controllers

  const [handleRoleList, setRoleList] = useState();

  const requestRoleList = async (pageIndex) => {
    const result = await RoleListService(pageIndex);
    if (result && result.payload) {
      const { payload } = result;
      const roleArray = Object.entries(payload.data);
      setRoleList(payload.data);
    }
  };

  useEffect(() => {
    requestRoleList();
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Typography id="modal-modal-title" component="h2">
            Editando usuario: {getFieldValue("name")}
          </Typography>
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={handleClose}
          >
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Nombres
        </Typography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("name")}
          error={!isFieldValid.name}
          helperText={!isFieldValid.name ? "Sin numeros ni caracteres especiales." : ""}
          FormHelperTextProps={{ className: !isFieldValid.name ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("name", e.target.value)}
        />
        <br />
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Apellidos
        </Typography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("lastname")}
          error={!isFieldValid.lastname}
          helperText={!isFieldValid.lastname ? "Sin numeros ni caracteres especiales." : ""}
          FormHelperTextProps={{ className: !isFieldValid.lastname ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("lastname", e.target.value)}
        />
        <br />
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Correo electrónico
        </Typography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "6px" }}
          value={getFieldValue("email")}
          error={!isFieldValid.email}
          helperText={!isFieldValid.email ? "Digite un email valido." : ""}
          FormHelperTextProps={{ className: !isFieldValid.email ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("email", e.target.value)}
        />
        <br />
        <Divider variant="middle" />
        <form onSubmit={handleSubmit}>
          <Box display="flex" alignItems="flex-start">
            <Box sx={{ marginRight: "20px" }}>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Rol
              </Typography>
              <FormControl sx={{ minWidth: 80 }} error={!isFieldValid.role_id}>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={getFieldValue("role_id")}
                  onChange={(e) => handleFieldChange("role_id", e.target.value)}
                  style={{ fontSize: "15px", padding: "10px" }}
                  disabled={isDisabled}
                  displayEmpty
                >
                  <MenuItem value={""}>Seleccione...</MenuItem>
                  {(handleRoleList ?? []).map((role) => (
                    <MenuItem key={role.id} value={role.id}>
                      {role.name}
                    </MenuItem>
                  ))}
                </Select>
                {!isFieldValid.role_id && <FormHelperText>Rol requerido</FormHelperText>}
              </FormControl>
            </Box>
            <Box>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Estado
              </Typography>
              <FormControl error={!isFieldValid.status}>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={getFieldValue("status")}
                  onChange={(e) => handleFieldChange("status", e.target.value)}
                >
                  <FormControlLabel
                    disabled={isDisabled}
                    value={"Activo"}
                    control={<Radio />}
                    label="Activo"
                  />
                  <FormControlLabel
                    disabled={isDisabled}
                    value={"Inactivo"}
                    control={<Radio />}
                    label="Inactivo"
                  />
                </RadioGroup>
                {!isFieldValid.status && <FormHelperText>Rol requerido</FormHelperText>}
              </FormControl>
            </Box>
          </Box>
          <Divider variant="middle" />
          <Box
            style={{
              display: "flex",
              gap: "5px",
              justifyContent: "flex-end",
            }}
          >
            <MDButton onClick={handleClose} color="error">
              Cancelar
            </MDButton>
            <MDButton type="submit" disabled={isDisabled || !isFormModified} color="success">
              Actualizar
            </MDButton>
          </Box>
        </form>
      </Card>
    </Modal>
  );
}

UserEdit.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  datosRecuperados: PropTypes.object,
  isDisabled: PropTypes.bool,
  datosEditados: PropTypes.object,
  getFieldValue: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isFormModified: PropTypes.bool,
  listRoles: PropTypes.array,
};
